import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from "vue";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'CardWidget',
  props: {
		css: {
			type: String,
			default: "justify-center items-center",
		},
		cursorPointer: {
			type: Boolean,
			default: true,
		},
	},
  setup(__props) {

	const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.css, { 'flex bg-[#0D181C] rounded-xl h-[50px] p-4': true, 'cursor-pointer': props.cursorPointer }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})